import gtag from 'ga-gtag';
import { getCLS, getFID, getLCP } from 'web-vitals';

const sendToGoogleAnalytics = ({ name, delta, id }) => {
  gtag('event', name, {
    event_category: 'Web Vitals',
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    event_label: id,
    non_interaction: true
  });
};

export default () => {
  getCLS(sendToGoogleAnalytics);
  getFID(sendToGoogleAnalytics);
  getLCP(sendToGoogleAnalytics);
};
